import {
  SUGGEST_RESTAURANT_NAME,
  ACCEPT_SUGGESTION,
  DECLINE_SUGGESTION,
  CHANGE_RESTAURANT,
  ADD_OR_REMOVE_ITEM,
  GET_RESTAURANTS,
  GET_RESTAURANT_MENU,
  LOGOUT,
  SUGGESTED_MENU_ITEM,
  WHICH_ITEMS_ARE_SUGGESTED,
  RESET_WHICH_ITEMS_ARE_SUGGESTED,
  REMOVE_ITEM_FROM_CART,
  EMPTY_DELIVERY_DOT_COM_CART,
  TOGGLE_ADD_TO_CART_POPUP,
  REMOVE_ITEM_FROM_SUGGESTED_LIST,
  GET_CART_ITEMS_FROM_DELIVERY,
  SET_PARTNER_CART_STATUS,
  SET_SUGGESTED_ITEMS,
  PARTNER_READY_FOR_CHECKOUT,
  ADDED_TO_THEIR_CART,
  REMOVED_FROM_THEIR_CART,
  NOTIFY_SUBSCRIBED,
  SELECTED_ITEM_OPTIONS,
  GET_RESTAURANT_MENU_FAIL,
} from "../types/types"
import { NOTIFY_WHEN_RESTAURANTS_OPEN } from "../../constants/messages"
import _ from "../../utils/lodashUtils"

const initialState = {
  suggestedRestaurantId: "",
  suggestedRestaurantName: "",
  suggested: false,
  acceptSuggestion: false,
  declinedSuggestion: false,
  changeRestaurant: false,
  restaurants: {},
  itemsInCart: {},
  restaurantMenu: {},
  selectedItemOptions: {},
  iSuggested: "",
  isUpdate: false,
  suggestedMenuItems: {},
  whichItemAreSuggested: {},
  restDisclaimerText: "",
  showAddToCartPopup: false,
  menuItemInAddToCartPopup: {},
  deliveryDotComCart: {},
  restaurantSuggested: {},
  partnerCartStatus: {},
  partnerReadyForCheckout: false,
  fetchingRestaurantData: false,
  partnerAddedToTheirCart: {},
  notifyMessage: "",
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case SUGGEST_RESTAURANT_NAME:
      return {
        ...state,
        restaurantSuggested: payload,
        suggested: true,
      }

    case ACCEPT_SUGGESTION:
      return {
        ...state,
        suggested: false,
        acceptSuggestion: true,
        declinedSuggestion: false,
      }

    case DECLINE_SUGGESTION:
      return {
        ...state,
        suggested: false,
        declinedSuggestion: true,
        acceptSuggestion: false,
      }
    case CHANGE_RESTAURANT:
      return {
        ...state,
        suggested: false,
        declinedSuggestion: false,
        acceptSuggestion: false,
        changeRestaurant: true,
      }
    case GET_RESTAURANTS:
      return {
        ...state,
        restaurants: payload,
        fetchingRestaurantData: false,
      }
    case TOGGLE_ADD_TO_CART_POPUP:
      const menuItemInAddToCartPopup = payload.showPopup ? payload.item : {}
      return {
        ...state,
        selectedItemOptions: payload.showPopup ? state.selectedItemOptions : {},
        menuItemInAddToCartPopup,
        showAddToCartPopup: payload.showPopup,
        isUpdate: payload.isUpdate,
      }
    case SELECTED_ITEM_OPTIONS:
      const optionList = _.get(action, "payload", {})
      return {
        ...state,
        selectedItemOptions: optionList,
      }

    case ADD_OR_REMOVE_ITEM:
      const prevState = { ...state.itemsInCart }
      const item = _.get(action, "payload.value", {})
      switch (payload.operation) {
        case "+":
          if (prevState[item.item_id]) {
            prevState[item.item_id] = {
              ...prevState[item.item_id],
              quantity: payload.quantity + 1 || 1,
            }
          } else {
            prevState[item.item_id] = { quantity: payload.quantity || 1 }
          }
          break
        case "-":
          if (prevState[item.item_id] && prevState[item.item_id].quantity > 0) {
            prevState[item.item_id] = {
              ...prevState[item.item_id],
              quantity: payload.quantity + 1 || 1,
            }
          }
          break
      }
      return {
        ...state,
        itemsInCart: prevState,
        deliveryDotComCart: payload.deliveryDotComCart,
        showAddToCartPopup: false,
      }
    case REMOVE_ITEM_FROM_CART:
      const itemsInCart = { ...state.itemsInCart }
      delete itemsInCart[payload.itemId]
      return {
        ...state,
        itemsInCart,
        deliveryDotComCart: payload.deliveryDotComCart,
      }
    case EMPTY_DELIVERY_DOT_COM_CART:
      return {
        ...state,
        suggested: false,
        acceptSuggestion: false,
        declinedSuggestion: false,
        itemsInCart: {},
        iSuggested: "",
        suggestedMenuItems: {},
        whichItemAreSuggested: {},
        showAddToCartPopup: false,
        menuItemInAddToCartPopup: {},
        deliveryDotComCart: {},
        partnerCartStatus: {},
        partnerReadyForCheckout: false,
        partnerAddedToTheirCart: {},
      }
    case GET_RESTAURANT_MENU:
      return {
        ...state,
        restaurantMenu: payload.menus,
        restDisclaimerText: payload.restDisclaimerText,
      }
    case GET_RESTAURANT_MENU_FAIL:
      return {
        ...state,
        restaurantMenu: {},
        restDisclaimerText: "",
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    case SUGGESTED_MENU_ITEM:
      const suggestedMenuItems = { ...state.suggestedMenuItems }
      const payloadItemId = _.get(payload, "item.id", "")
      if (payloadItemId) {
        suggestedMenuItems[payloadItemId] = payload
      }
      return {
        ...state,
        suggestedMenuItems,
      }
    case WHICH_ITEMS_ARE_SUGGESTED: {
      const prevState = { ...state.whichItemAreSuggested }
      const { item } = payload
      prevState[item.id] = payload
      return {
        ...state,
        whichItemAreSuggested: prevState,
      }
    }
    case RESET_WHICH_ITEMS_ARE_SUGGESTED:
      return {
        ...state,
        whichItemAreSuggested: {},
      }
    case REMOVE_ITEM_FROM_SUGGESTED_LIST:
      const filteredItems = Object.values(
        _.get(state, "suggestedMenuItems", {})
      ).filter((item) => payload.id !== item.id)
      return {
        ...state,
        selectedItemOptions: {},
        suggestedMenuItems: filteredItems,
      }
    case GET_CART_ITEMS_FROM_DELIVERY:
      return {
        ...state,
        itemsInCart: payload.itemsInCart,
        deliveryDotComCart: payload.deliveryDotComCart,
      }

    case SET_PARTNER_CART_STATUS:
      return {
        ...state,
        partnerCartStatus: payload || [],
      }

    case SET_SUGGESTED_ITEMS:
      return {
        ...state,
        suggestedMenuItems: payload || {},
      }

    case PARTNER_READY_FOR_CHECKOUT:
      return {
        ...state,
        partnerReadyForCheckout: payload,
      }
    case ADDED_TO_THEIR_CART: {
      const prevState = { ...state.partnerAddedToTheirCart }
      const { item } = payload.item
      prevState[item.id] = payload.item
      return {
        ...state,
        partnerAddedToTheirCart: prevState,
      }
    }
    case REMOVED_FROM_THEIR_CART: {
      const filteredItems = Object.values(
        _.get(state, "partnerAddedToTheirCart", {})
      ).filter((item) => payload.id !== item.id)
      return {
        ...state,
        partnerAddedToTheirCart: filteredItems,
      }
    }
    case NOTIFY_SUBSCRIBED:
      return {
        ...state,
        notifyMessage: NOTIFY_WHEN_RESTAURANTS_OPEN,
      }
    default:
      return state
  }
}
